import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { BigPushBlockConfig } from '@front-platform/content-builder';
import { bigPushBlockResolveConfig } from '@front-platform/content-builder';
import { RouterHelperService } from './../../../core/services/router-helper/router-helper.service';
import { Component, input } from '@angular/core';
import {
  IContentBuilderFieldColor,
  IContentBuilderFieldImage,
} from '@core/models/content-builder-fields.model';
import { Router } from '@angular/router';
import { AnalyticsService } from '@core/services/app/analytics.service';
export interface BigPushBlockRuntimeConfig {}

export type BigPushBlockConfigInput = Partial<
  Omit<BigPushBlockConfig, keyof BigPushBlockRuntimeConfig> & BigPushBlockRuntimeConfig
>;
export type BigPushBlockResolvedConfig = Omit<BigPushBlockConfig, keyof BigPushBlockRuntimeConfig> &
  Partial<BigPushBlockRuntimeConfig>;
export interface BigPushBlockContract extends ConfigComponentContract<
  BigPushBlockConfigInput,
  BigPushBlockResolvedConfig
> {}

@Component({
  selector: 'app-big-push-block',
  templateUrl: './big-push-block.component.html',
  standalone: false,
})
export class BigPushBlockComponent implements BigPushBlockContract {
  readonly config = input<BigPushBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<BigPushBlockConfig, BigPushBlockRuntimeConfig>(
    bigPushBlockResolveConfig,
    () => ({ config: this.config() }),
  );
  get heading(): string | undefined {
    return this.resolvedConfig()['heading'] as unknown as string | undefined;
  }
  get text(): string | undefined {
    return this.resolvedConfig()['text'] as unknown as string | undefined;
  }
  get buttonLabel(): string | undefined {
    return this.resolvedConfig()['button_label'] as unknown as string | undefined;
  }
  get buttonLink(): string | undefined {
    return this.resolvedConfig()['button_link'] as unknown as string | undefined;
  }
  get icon(): IContentBuilderFieldImage | undefined {
    return this.resolvedConfig()['icon'] as unknown as IContentBuilderFieldImage | undefined;
  }
  get backgroundColor(): IContentBuilderFieldColor | undefined {
    return this.resolvedConfig()['background_color'] as unknown as
      IContentBuilderFieldColor | undefined;
  }
  get externalLink(): boolean | undefined {
    return this.resolvedConfig()['external_link'] as unknown as boolean | undefined;
  }

  constructor(
    private readonly router: Router,
    private readonly routerHelper: RouterHelperService,
    private readonly analyticsService: AnalyticsService,
  ) {}

  buttonClick(_$event: Event): void {
    if (this.externalLink && this.buttonLink) {
      window.location.href = this.buttonLink;
    } else {
      this.router.navigate([
        this.buttonLink ? this.routerHelper.translateRoute(this.buttonLink) : this.buttonLink,
      ]);
    }
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(BigPushBlockComponent, { 'keyAliases': {} });
